import Summary from "../components/inventory/buy/summary";
import Nav from "../components/inventory/vendor/navbar";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <Summary />
    </div>
  );
};

export default ListingPage;